export default __webpack_public_path__ + "static/media/thumb-down-red.6c095307.svg";